<template>
  <a-link
    v-if="isCalifornia"
    class="do-not-sell-link text-small"
    :to="linkToContactUs"
  >
    {{ CMP_CCPA_CONTACT_US_LINK_TEXT }}
  </a-link>
</template>

<script>
import mixins from '@/utils/mixins'
import { CMP_CCPA_CONTACT_US_LINK_TEXT } from 'enums/cmp'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'FooterDoNotSellLink',
  mixins: [mixins.cmp],
  data() {
    return {
      CMP_CCPA_CONTACT_US_LINK_TEXT,
      isCalifornia: false,
      linkToContactUs: {
        name: ROUTE_NAME.CONTACT_US
      }
    }
  },
  mounted() {
    this.isCalifornia = this.$_cmp_isCalifornia()
  }
}
</script>

<style lang="scss" scoped>
.do-not-sell-link {
  color: $c--main;
  cursor: pointer;
  text-decoration: underline;
}
</style>
